import * as React from 'react';
import { useTranslation } from 'react-i18next';
import CRUDDataTable from 'dashboard/containers/CRUDDataTable';
import { getUsersWithInvoices } from 'dashboard/_redux/actions/invoices';
import { useInvoiceList } from './useInvoiceList';

const InvoiceList: React.FC = () => {
  const { usersWithInvoices, loaded, columns, dataTableRef } = useInvoiceList();
  const [t] = useTranslation();

  return (
    <div className="card card-body pt-10">
      <CRUDDataTable
        myRef={dataTableRef}
        loading={!loaded}
        data={usersWithInvoices}
        title={t('dashboard.invoicesPage.title')}
        columns={columns}
        fetchDataFn={getUsersWithInvoices}
      />
    </div>
  );
};

export default InvoiceList;
